(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('TimeBoardController', TimeBoardController);

    TimeBoardController.$inject = ['$scope', '$location', '$window', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', '$translate', '$localStorage', '$timeout'];

    function TimeBoardController($scope, $location, $window, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, translate, $localStorage, $timeout) {
        var vm = this;
        vm.schedulerApi = {refresh: 'not set'};
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.categoryName = categoryName;
        vm.storeInDefaults = storeInDefaults;
        vm.getFromDefaults = getFromDefaults;
        vm.startRefreshTimer = startRefreshTimer;
        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {

            //  var path = $location.path();
            //if ((path == '/supplierPanel/timeBoard' || path == '/timeBoard') && result[0].company.appVersion == 'v2') {
            //    $window.location.href = '/#/supplierPanel/calendar';
            //}

            vm.categories = result;
            angular.forEach(result, function (item) {
                item.categoryName = categoryName(item.categoryName)
            })
        });

        vm.getFromDefaults();
        vm.startRefreshTimer();

        //vm.serviceItems=ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function(list){
        //   if(list && list.length>0) {
        //
        //       vm.selectedId=list[0].id;
        //       updateTimeBoard();
        //   }
        //
        //});
        vm.onServiceChanged = function () {
            vm.storeInDefaults();
            updateTimeBoard();
        }
        vm.onCategoryChanged = function () {

            if (vm.selectedCategoryId)
                vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCategory(vm.selectedCategoryId).query(function (list) {
                    if (list && list.length > 0) {
                        vm.selectedId = list[0].id;
                        vm.storeInDefaults();
                        updateTimeBoard();
                    }
                });
            else

                vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (list) {
                    if (list && list.length > 0) {
                        vm.getFromDefaults();
                        var isDefaultInList = false;
                        if (vm.selectedId != undefined)
                            angular.forEach(list, function (item) {
                                if (item.id == vm.selectedId)
                                    isDefaultInList = true;
                            });

                        if (vm.selectedId == undefined || !isDefaultInList) {
                            vm.selectedId = list[0].id;
                            vm.storeInDefaults();
                        }
                        updateTimeBoard();
                    }

                });

        }

        function startRefreshTimer() {
            setInterval(function () {
                vm.updateTimeBoard();
            }, 300000)


        }

        vm.updateTimeBoard = updateTimeBoard;

        function updateTimeBoard() {
            var serviceList = [];
            serviceList.push(vm.selectedId);
            TimingInfo.getTimingInfoByServiceItems.save({serviceItemIds: serviceList}, function (t) {
                vm.timingInfo = t;

            })
        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function storeInDefaults() {
            console.log('storing in storage :' + vm.selectedId)
            if (vm.selectedId != undefined)
                $localStorage.selectedId = vm.selectedId;
        }

        function getFromDefaults() {
            console.log('reading from storage :' + vm.selectedId)
            if ($localStorage.selectedId != undefined) {

                var serviceList = [];
                vm.selectedId = $localStorage.selectedId;
                console.log('exista storage :' + vm.selectedId)
            }
        }
    }
})();
